module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0002.jpg?v=1985adab";